import store from "@/store/index";

export interface AppAdministratorPlayersCategoriesListFormCreate {
  organization_id: string;
  content: {
    name: string;
    from: number;
    to: number;
  };
}

export class AppAdministratorPlayersCategoriesListFormCreate implements AppAdministratorPlayersCategoriesListFormCreate {
  organization_id: string;
  content: {
    name: string;
    from: number;
    to: number;
  };

  constructor() {
    this.organization_id = store.getters.getOrganizationMember.organization_id ?? "";
    this.content = {
      name: "",
      from: null,
      to: null,
    };
  }
}